import { heroEquipment } from "../HeroEquipment";

export const eshin = {
  heroes: {
    Nocarz: {
      id: 0,
      startingEquipment: ["Sztylet", "Dmuchawka"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Zwiadowcze stado klanu Eshin"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [6, 4, 4, 3, 3, 2, 5, 1, 7],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Dowódca",
        "Mistrz skrytobójstwa",
        "Ranger",
        "W nogi!",
        "Strachliwy",
        "Zasadzka",
      ],
      exp: 20,
      skills: [0, 1, 4, 5],
    },
    Zaklinacz: {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Zwiadowcze stado klanu Eshin"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [6, 3, 3, 3, 3, 1, 4, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Mag (Tradycja Skrytości", "Ranger", "W nogi!", "Zasadzka"],
      exp: 8,
      skills: [0, 2, 4, 5],
    },
    Czarnoszczur: {
      id: 2,
      startingEquipment: ["Sztylet", "Halabarda"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Zwiadowcze stado klanu Eshin"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [6, 4, 3, 3, 3, 1, 5, 1, 5],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Krzepki", "Podoficer", "Ranger", "W nogi!", "Zimnokrwisty"],
      exp: 8,
      skills: [0, 1, 3, 4, 5],
    },
    "Łowca niewolników": {
      id: 3,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Zwiadowcze stado klanu Eshin"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [6, 3, 3, 3, 3, 1, 5, 1, 5],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Handlarz niewolników", "Ranger", "W nogi!"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    "Posłaniec nocy": {
      id: 5,
      startingEquipment: ["Sztylet", "Broń miotana (gwiazdki)"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Zwiadowcze stado klanu Eshin"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 3, 3, 3, 1, 5, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Ranger",
        "W nogi!",
        "Zasadzka",
        "Cichy marsz",
      ],
    },
    Rynsztokowiec: {
      id: 6,
      startingEquipment: ["Sztylet", "Khutar"],
      cost: 30,
      number: 7,
      equipmentList:
        heroEquipment["Zwiadowcze stado klanu Eshin"].Rynsztokowiec,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 4, 3, 3, 3, 1, 5, 1, 6],
        Maksymalna: [6, 6, 6, 4, 4, 3, 7, 4, 7],
      },
      rules: ["Ranger","Saper","W nogi!","Zasadzka","Zwiadowca"],
    },
    "Wielki szczur": {
      id: 7,
      startingEquipment: ["Broń naturalna"],
      cost: 15,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 2, 0, 3, 3, 1, 4, 1, 3],
        Maksymalna: [6, 2, 0, 3, 3, 1, 4, 1, 3],
      },
      rules: ["Murołaz", "Sfora", "W nogi!", "Wodny", "Zwierzę"],
    },
    Rydwan: {
      id: 8,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Wilkoszczur: [9, 3, 0, 3, "-", "-", 4, 1, 3],
        "Wilkoszczur ": [9, 3, 0, 3, "-", "-", 4, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
    Więźniarka: {
      id: 9,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Wilkoszczur: [9, 3, 0, 3, "-", "-", 4, 1, 3],
        "Wilkoszczur ": [9, 3, 0, 3, "-", "-", 4, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Zwiadowcze stado klanu Eshin",
  nature: "Chaotyczna",
  armyRules: ["Rozrzutność"],
  mercenaries: ["Szczurogr", "Szpieg", "Złodziej"],
};
